export default __webpack_public_path__ + "static/media/DidYouKnow.7d90e1f4.svg";